module.exports = __webpack_public_path__ + "static/media/empty_post.abb61c67.png";